import { BuilderContent } from '../ContentBuilder';

// toSnakeCaseKeys in remiApi.ts converts camelCase → snake_case before saving to the API.
// This reverses that conversion so BuilderContent loaded from the API maps back to camelCase keys.
const toCamelCaseKeys = (data: unknown): unknown => {
  if (Array.isArray(data)) return data.map(toCamelCaseKeys);
  if (data !== null && typeof data === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(data as Record<string, unknown>)) {
      const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
      result[camelKey] = toCamelCaseKeys(value);
    }
    return result;
  }
  return data;
};

export const normalizeBuilderContent = (content: unknown): BuilderContent | null => {
  if (!content) return null;
  if (typeof content === 'string') {
    try {
      return toCamelCaseKeys(JSON.parse(content)) as BuilderContent;
    } catch {
      return null;
    }
  }
  return toCamelCaseKeys(content) as BuilderContent;
};
